import { render } from "./Order.vue?vue&type=template&id=d0b60bf8&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=d0b60bf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0b60bf8"

export default script